import { memo, forwardRef } from "react";
import { CustomContentProps, SnackbarContent } from "notistack";
import styles from "./ThemeResponsiveSnackbar.module.scss";
import { ErrorIcon, SuccessIcon } from "../../assets/icons/SnackBarIcons";

const ThemeResponsiveSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, forwardedRef) => {
    const { message, variant } = props;
    const rootClass = `${styles.root} ${styles[variant]}`;

    const iconMap: Record<string, JSX.Element> = {
      success: <SuccessIcon />,
      error: <ErrorIcon />,
    };

    return (
      <SnackbarContent
        ref={forwardedRef}
        className={rootClass}
      >
        <div className={styles.message}>
          {iconMap[variant]}
          {message}
        </div>
      </SnackbarContent>
    );
  }
);

export default memo(ThemeResponsiveSnackbar);
